import Action, { GetContext, } from './Action';
const ReplyBody = Symbol('body');
export default class Reply extends Action {
    constructor(body) {
        if (typeof body !== 'string' || !body.length) {
            throw new TypeError('Reply constructor expects a non-empty string as the first argument');
        }
        super();
        this[ReplyBody] = body;
        this[GetContext] =
            () => ({ body });
    }
    get body() {
        return this[ReplyBody];
    }
}
